import { render, staticRenderFns } from "./HomeBrandAmbassador.vue?vue&type=template&id=a625fce6&"
import script from "./HomeBrandAmbassador.vue?vue&type=script&lang=js&"
export * from "./HomeBrandAmbassador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports